// Event bridge to connect notification system with chat UI updates
class ChatEventBridge {
  private listeners: { [key: string]: Array<(data: any) => void> } = {};

  // Add event listener
  on(event: string, callback: (data: any) => void) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  // Remove event listener
  off(event: string, callback: (data: any) => void) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  // Emit event
  emit(event: string, data: any) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error('Error in chat event bridge callback:', error);
        }
      });
    }
  }

  // Clear all listeners
  clear() {
    this.listeners = {};
  }
}

// Export singleton instance
export const chatEventBridge = new ChatEventBridge();